(function () {
  var subscribers = {};

  var PUB_SUB_EVENTS = {
    cartUpdate: 'cart-update',
    cartError: 'cart-error',
  };

  function subscribe(eventName, callback) {
    if (subscribers[eventName] === undefined) {
      subscribers[eventName] = [];
    }
    subscribers[eventName].push(callback);
    return function unsubscribe() {
      subscribers[eventName] = subscribers[eventName].filter(function (cb) {
        return cb !== callback;
      });
    };
  }

  function publish(eventName, data) {
    if (!subscribers[eventName]) return;
    subscribers[eventName].forEach(function (callback) {
      callback(data);
    });
  }

  window.DisuriPubSub = {
    subscribe: subscribe,
    publish: publish,
    events: PUB_SUB_EVENTS,
  };
})();
